
export default {

    components: {
        ElButton: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElButton")
    },

    data() {
        return {
            loading_export: false,
            success_export: false,
            selectedForExport: [],
            export_name: 'Appvalvas-csv-export'
        }
    },
    methods: {
        exportableChanged(changes) {
            this.selectedForExport = changes.selectedRows.map(exp => {
                let exp_trimmed = Object.assign({}, exp)
                delete exp_trimmed.vgt_id;
                delete exp_trimmed.vgtSelected;
                delete exp_trimmed.originalIndex;
                delete exp_trimmed.creator;
                return { ...exp_trimmed }
            })
        },
        csvExport(array) {
            this.loading_export = true
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += Object.keys(array[0]).join(",") + '\r\n';
            csvContent += this.convertToCSV(JSON.stringify(array))
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", `${this.export_name}.csv`);
            link.click();
            this.loading_export = false
            this.success_export = true
        },
        convertToCSV(objArray) {
            var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
            let str = ''

            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line !== '') line += ','
                    if (array[i][index] && typeof array[i][index] === 'object') {
                        let nested_array = '['
                        for (var j in array[i][index]) {
                            if (!array[i][index][j]) continue
                            if (j != 0) nested_array += '|'
                            if (typeof array[i][index][j] !== 'object') nested_array += `${array[i][index][j]}`
                            else if (array[i][index][j].hasOwnProperty('name')) nested_array += `${array[i][index][j].name}`
                            else if (array[i][index][j].hasOwnProperty('first_name')) nested_array += `${array[i][index][j].first_name}`
                        }
                        line += `${nested_array}]`
                    } else {
                        line += array[i][index];
                    }
                }

                str += line + '\r\n';
            }

            return str;
        }
    }
}
